<template>
  <el-dialog
    width="600px"
    class="moduleDetails viewDialog"
    :visible.sync="visible"
    :close-on-click-modal="false">
    <div slot="title" class="dialogTitle moduleDetails_title">
      <span>xxx详情</span>
    </div>
    <div class="moduleDetails_con viewDialog_con lable">
      <el-row>
        <el-col :span="12">
          <p><span>xxx编码：</span>{{detailsData.code}}</p>
        </el-col>
        <el-col :span="12">
          <p><span>xxxesfd名称：</span>{{detailsData.name}}</p>
        </el-col>
        <el-col :span="12">
          <p><span>xxxsdf名称：</span>{{detailsData.name}}</p>
        </el-col>
        <el-col :span="12">
          <p><span>xxx名称：</span>{{detailsData.name}}</p>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
  // 接口
  import { testByGet } from '@/api/common';
  
  export default {
    name: 'moduleDetails',
    inject: ['myMessage'],
    props: {
      fatherData: Object
    },
    data () {
      return {
        visible: false,
        id: '',
        detailsData: {}
      };
    },
    watch: {
      visible (val, oldVal) {
        if (val) {
          this.id = parseInt(this.fatherData.id);
          this.requestDetails();
        } else {
          this.detailsData = {};
        }
      }
    },
    methods: {
      requestDetails () {
        testByGet(this.id)
          .then(res => {
            this.handleDetailsData(res.data);
          })
          .catch(() => {
            this.myMessage.megError('获取详情信息失败');
          });
      },
      
      handleDetailsData (data) {
        this.detailsData = { ...data };
      }
    }
  };
</script>

<style lang="scss">
  .moduleDetails {
    .lable p > span:first-child {
      /*min-width: 110px;*/
    }
  }
</style>
